// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.haztru0 {
  background-color: var(--_18w76bw25);
  min-height: calc(100vh - 150px);
  padding: var(--_18w76bwg) var(--_18w76bw9);
}
@media screen and (max-width: 767px) {
  .haztru0 {
    padding: var(--_18w76bwc) var(--_18w76bw9);
    min-height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,0CAA0C;AAC5C;AACA;EACE;IACE,0CAA0C;IAC1C,gBAAgB;EAClB;AACF","sourcesContent":[".haztru0 {\n  background-color: var(--_18w76bw25);\n  min-height: calc(100vh - 150px);\n  padding: var(--_18w76bwg) var(--_18w76bw9);\n}\n@media screen and (max-width: 767px) {\n  .haztru0 {\n    padding: var(--_18w76bwc) var(--_18w76bw9);\n    min-height: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
